import { ButtonContatct } from "./styles"

interface IInterestFeeback {
    mode: 'deactivated' | 'activated'
}
const InterestFeeback: React.FC<IInterestFeeback> = ({ mode }) => {

    const dialog = {
        deactivated: {
            title: 'Interesse removido com sucesso!',
            desc: 'Registramos que você não tem mais interesse no material. Caso queira tirar alguma dúvida fique a vontade para consultar a nossa equipe.',
        },
        activated: {
            title: 'Seu interesse foi registrado com sucesso!',
            desc: 'Você será avisado quando o material estiver disponível. Caso queira tirar alguma dúvida fique a vontade para consultar a nossa equipe.',
        }
    }

    const handleClick = () => {
        window.open('https://api.whatsapp.com/send/?phone=554891177086&text&app_absent=0', '_blank')
    }

    return (
        <div style={{ padding: 10 }}>
            <p><b>{dialog[mode].title}</b></p>
            <p style={{ fontSize: 14 }}>{dialog[mode].desc}</p>
            <ButtonContatct type='button' onClick={() => handleClick()} >

                <span>Entrar em contato</span>
            </ButtonContatct>
        </div>
    )
}


export default InterestFeeback;